import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../../store';

import {
	selectDatasetnumber,
	selectDatasetnumber2, selectIsOnesided,
	selectLdt1,
	selectLdt2, selectLePolar, selectLePolar2,
	selectPolar,
	selectPolar2,
	selectUlor,
	selectUlor2
} from '../../../selectors';
import {selectSolarLumPosition2IsVisible} from '../../solarSelectors';

@customElement('solar-polar-diagram')
export class SolarPolarDiagram extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: block;
	  }

	  @media (min-width: 768px) {
		/*bp-small*/
		:host {
		  display: block;
		}
	  }

	  a {
		color: #000;
	  }

	  .image {
		margin-bottom: var(--specsheet-large-gap);
	  }

	  .col {
		margin-right: var(--specsheet-large-gap);
	  }

	  .text {
		font: var(--font-specsheet-light);
	  }

	  @media print {
		:host {
		  display:block;
		}

		.image {
		  margin-bottom: var(--specsheet-print-small-large-gap);
		}

		.text {
		  font: var(--font-specsheet-print-light);
		}

	  }

	`
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
	}


	render() {
		const s = this.state;
		return html`

			<div class="col">
				<div class="image">
					<img src="${selectLePolar(s)}" alt="polar">
					<div class="text">${'Light point'} 1</div>
				</div>
				${when(selectSolarLumPosition2IsVisible(s), () => html`
					<div class="image">
						<img src="${selectLePolar2(s)}" alt="polar">
						<div class="text">${'Light point'} 2</div>
					</div>
				`)}
			</div>

		`;
	}
}
